"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _reactHelmetAsync = _interopRequireDefault(require("react-helmet-async"));

var _react = _interopRequireDefault(require("react"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _ErrorRedirect = _interopRequireDefault(require("./ErrorRedirect"));

var _Grid = _interopRequireDefault(require("angieslist-react-components/lib/Grid"));

var _Row = _interopRequireDefault(require("angieslist-react-components/lib/Row"));

var _Col = _interopRequireDefault(require("angieslist-react-components/lib/Col"));

var _errorStyles = _interopRequireDefault(require("./errorStyles"));

var _analytics = require("../../common/analytics");

var _errorAnalytics = require("./errorAnalytics");

var _angieslistStyles = require("angieslist-styles");

var _urlCatalog = _interopRequireDefault(require("../../common/urlCatalog"));

var _Helmet;

var MemberNotFoundView = function MemberNotFoundView() {
  return /*#__PURE__*/(0, _jsx2.default)("div", {}, void 0, _Helmet || (_Helmet = /*#__PURE__*/(0, _jsx2.default)(_reactHelmetAsync.default, {
    title: "Page Not Found"
  })), /*#__PURE__*/(0, _jsx2.default)(_Grid.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)(_Row.default, {
    style: _errorStyles.default.body
  }, void 0, /*#__PURE__*/(0, _jsx2.default)(_Col.default, {}, void 0, /*#__PURE__*/(0, _jsx2.default)("h1", {
    style: _errorStyles.default.title
  }, void 0, "Oops! This page was not found."), /*#__PURE__*/(0, _jsx2.default)("span", {
    style: _errorStyles.default.text404
  }, void 0, /*#__PURE__*/(0, _jsx2.default)("img", {
    id: "not-found",
    alt: "not found",
    src: _urlCatalog.default.media.notFoundConsumer()
  })), /*#__PURE__*/(0, _jsx2.default)(_ErrorRedirect.default, {
    style: _errorStyles.default.redirect
  })))));
};

var _default = (0, _compose.default)((0, _analytics.analytics)({
  ruleset: _errorAnalytics.notFoundPageAnalytics
}), _pure.default)(MemberNotFoundView);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/error/MemberNotFoundView.js
// module id = 4054
// module chunks = 25